import React, { useEffect } from "react";
import Header from "../Templete/Header";
import Footer from "../Templete/Footer";

const RefundPolicy = () => {
  useEffect(() => {
    document.title = "Refund & Cancellation Policy | FORMAX MONEY";
  }, []);

  return (
    <>
      <Header />

      {/* Hero Section */}
      <section className="page-hero">
        <div className="container">
          <h1>Refund & Cancellation Policy</h1>
          <p>
            Clear guidelines on refunds, cancellations, and dispute resolution
            for BC Agents and customers of FORMAX MONEY.
          </p>
        </div>
      </section>

      <div className="container">
        <div className="refund-content">
          <div className="refund-card">
            <h2>1. Introduction</h2>
            <p>
              This Refund & Cancellation Policy ("Policy") applies to all
              transactions conducted through FORMAX MONEY, operated by{" "}
              <strong>FORMAX IT SOLUTIONS PRIVATE LIMITED</strong>. As a
              bank-licensed Corporate Business Correspondent, we facilitate
              financial transactions including AEPS, DMT, CMS, UPI Cash Point,
              and other banking services. Please read this Policy carefully
              before initiating any transaction.
            </p>
            <p>
              By using our services, you acknowledge and agree to the terms of
              this Policy. If you do not agree, please refrain from using our
              platform.
            </p>
          </div>

          <div className="refund-card">
            <h2>2. No Refunds for Successful Transactions</h2>
            <p>
              <strong>
                FORMAX MONEY does not offer refunds for successfully completed
                transactions.
              </strong>
              Once a transaction (AEPS withdrawal, DMT transfer, UPI Cash Point,
              etc.) is successfully processed and confirmed by the respective
              bank or service provider, the transaction is considered final and
              irreversible.
            </p>
            <p>Examples of successful transactions include:</p>
            <ul>
              <li>
                AEPS cash withdrawal successfully debited from customer's
                account
              </li>
              <li>
                DMT transfer successfully credited to beneficiary bank account
              </li>
              <li>UPI Cash Point transaction completed successfully</li>
              <li>CMS cash collection/delivery confirmed</li>
            </ul>
          </div>

          <div className="refund-card">
            <h2>3. Auto-Refund for Failed Transactions</h2>
            <p>
              If a transaction fails due to technical reasons, banking issues,
              or network problems, the amount will be automatically refunded to
              the original source within the specified timeframe:
            </p>
            <ul>
              <li>
                <strong>AEPS/DMT/UPI Transactions:</strong> Refund processed
                within 5-7 business days to the customer's bank account.
              </li>
              <li>
                <strong>Wallet Transactions:</strong> Refund credited within 3-5
                business days to the BC Agent's wallet.
              </li>
            </ul>
            <p className="note">
              <strong>Note:</strong> The actual credit to your account depends
              on your bank's processing time. We are not responsible for delays
              caused by your bank or payment gateway.
            </p>
          </div>

          <div className="refund-card">
            <h2>4. Transaction Disputes & Chargebacks</h2>
            <p>
              In case of any dispute regarding a transaction, the following
              process applies:
            </p>
            <ul>
              <li>
                <strong>Step 1:</strong> Report the issue to FORMAX MONEY
                support within 48 hours of the transaction.
              </li>
              <li>
                <strong>Step 2:</strong> Provide transaction details including
                transaction ID, amount, date, time, and customer/beneficiary
                information.
              </li>
              <li>
                <strong>Step 3:</strong> We will initiate an investigation with
                the respective bank or service provider.
              </li>
              <li>
                <strong>Step 4:</strong> Resolution will be provided within
                15-30 business days based on bank investigation results.
              </li>
            </ul>
            <p>
              <strong>Important:</strong> Disputes raised after 48 hours may not
              be entertained due to banking investigation timelines.
            </p>
          </div>

          <div className="refund-card">
            <h2>5. BC Agent Commission Adjustments</h2>
            <p>
              For BC Agents registered with FORMAX MONEY, the following applies
              to commission adjustments:
            </p>
            <ul>
              <li>
                <strong>Successful Transactions:</strong> Commission earned is
                final and non-reversible.
              </li>
              <li>
                <strong>Failed Transactions:</strong> No commission is earned on
                failed transactions.
              </li>
              <li>
                <strong>Chargebacks/Reversals:</strong> If a transaction is
                reversed by the bank due to fraud, technical error, or
                unauthorized activity, the corresponding commission will be
                debited from the BC Agent's account.
              </li>
              <li>
                <strong>Disputed Transactions:</strong> Commission for disputed
                transactions will be held until resolution.
              </li>
            </ul>
          </div>

          <div className="refund-card">
            <h2>6. Customer Dispute Resolution for BC Agents</h2>
            <p>
              As a BC Agent, you are responsible for handling customer disputes
              professionally. The following guidelines apply:
            </p>
            <ul>
              <li>
                Assist customers in checking their bank statements before
                raising a dispute.
              </li>
              <li>
                Provide customers with transaction receipts and reference
                numbers.
              </li>
              <li>
                Report genuine disputes to FORMAX MONEY support within 24 hours.
              </li>
              <li>
                Do not issue cash refunds to customers without verification from
                FORMAX MONEY.
              </li>
              <li>
                Fraudulent claims or misrepresentation by BC Agents will result
                in immediate termination and legal action.
              </li>
            </ul>
          </div>

          <div className="refund-card">
            <h2>7. Cancellation Policy</h2>
            <p>
              <strong>No Cancellation Once Initiated:</strong> Once a
              transaction is initiated, it cannot be cancelled or modified. This
              includes:
            </p>
            <ul>
              <li>AEPS withdrawal requests</li>
              <li>DMT transfer requests</li>
              <li>UPI Cash Point transactions</li>
              <li>CMS service requests</li>
            </ul>
            <p>
              Please verify all details (amount, beneficiary, customer
              information) before confirming any transaction. FORMAX MONEY is
              not responsible for errors made by BC Agents or customers.
            </p>
          </div>

          <div className="refund-card">
            <h2>8. Refund Exceptions</h2>
            <p>
              In rare circumstances, refunds may be considered outside the
              standard policy at the sole discretion of FORMAX MONEY management:
            </p>
            <ul>
              <li>
                <strong>Duplicate Transactions:</strong> If the same transaction
                is processed twice due to a technical glitch.
              </li>
              <li>
                <strong>Wrong Beneficiary:</strong> If funds were sent to the
                wrong beneficiary due to a proven system error (not user error).
              </li>
              <li>
                <strong>Unauthorized Transactions:</strong> If a transaction was
                processed without proper authorization and proven after
                investigation.
              </li>
            </ul>
            <p>
              All exception requests must be submitted in writing to
              <strong> support@formaxmoney.in</strong> with supporting evidence.
            </p>
          </div>

          <div className="refund-card">
            <h2>9. Chargeback Process</h2>
            <p>
              If a customer initiates a chargeback through their bank, the
              following process applies:
            </p>
            <ul>
              <li>
                The chargeback will be investigated by the respective bank.
              </li>
              <li>
                Funds may be temporarily frozen pending investigation outcome.
              </li>
              <li>
                If the chargeback is valid, the amount will be reversed to the
                customer's account.
              </li>
              <li>
                If the chargeback is invalid, funds will be released back to the
                BC Agent/customer.
              </li>
              <li>
                A chargeback processing fee of up to ₹500 may be levied by the
                bank, which will be borne by the BC Agent if the chargeback is
                found to be invalid or due to agent error.
              </li>
            </ul>
          </div>

          <div className="refund-card">
            <h2>10. Fraud Prevention & Liability</h2>
            <p>
              FORMAX MONEY takes fraud prevention seriously. The following
              actions are strictly prohibited:
            </p>
            <ul>
              <li>
                Knowingly processing transactions without customer consent.
              </li>
              <li>Fabricating transaction disputes for refunds.</li>
              <li>Colluding with customers to claim false refunds.</li>
              <li>
                Using stolen or unauthorized credentials for transactions.
              </li>
            </ul>
            <p>
              Violations will result in immediate termination of BC Agent
              privileges, forfeiture of pending commissions, and reporting to
              law enforcement authorities under applicable laws including the
              Information Technology Act, 2000 and Indian Penal Code.
            </p>
          </div>

          <div className="refund-card">
            <h2>11. Time Limits for Dispute Reporting</h2>
            <p>
              To ensure timely resolution, please adhere to the following time
              limits:
            </p>
            <ul>
              <li>
                <strong>Transaction Failure:</strong> Report within 48 hours of
                the transaction.
              </li>
              <li>
                <strong>Wrong Credit/Debit:</strong> Report within 24 hours of
                noticing the discrepancy.
              </li>
              <li>
                <strong>Unauthorized Transaction:</strong> Report immediately
                but no later than 24 hours from transaction time.
              </li>
              <li>
                <strong>AEPS/Banking Issues:</strong> Report within 48 hours.
              </li>
            </ul>
            <p>
              Delays in reporting may result in inability to process refunds due
              to banking investigation windows.
            </p>
          </div>

          <div className="refund-card">
            <h2>12. How to Raise a Refund Request</h2>
            <p>To raise a refund or dispute request, follow these steps:</p>
            <ol>
              <li>
                Contact FORMAX MONEY support via email at{" "}
                <strong>support@formaxmoney.in</strong> or call{" "}
                <strong>+91 7890090500</strong>.
              </li>
              <li>
                Provide the following details:
                <ul>
                  <li>Transaction ID / Reference Number</li>
                  <li>Date and time of transaction</li>
                  <li>Amount</li>
                  <li>BC Agent ID (if applicable)</li>
                  <li>Customer name and mobile number</li>
                  <li>Screenshot of bank statement (if available)</li>
                  <li>Detailed description of the issue</li>
                </ul>
              </li>
              <li>
                Our support team will acknowledge your request within 24 hours.
              </li>
              <li>
                We will investigate and provide a resolution within 15-30
                business days.
              </li>
            </ol>
          </div>

          <div className="refund-card">
            <h2>13. Escalation Matrix</h2>
            <p>
              If your refund request is not resolved satisfactorily, you may
              escalate to:
            </p>
            <p>
              <strong>Level 1:</strong> Customer Support -
              support@formaxmoney.in
              <br />
              <strong>Level 2:</strong> Senior Support Manager -
              support@formaxmoney.in
              <br />
              <strong>Level 3:</strong> Grievance Officer - admin@formaxmoney.in
            </p>
            <p>
              <strong>Grievance Officer Contact:</strong>
              <br />
              Mr. Ezazul Haque (Compliance Officer)
              <br />
              Email: admin@formaxmoney.in
              <br />
              Phone: +91 7890090500
              <br />
              Address: N0060, Mochpole, Near Junior School, Nabapally, Barasat,
              Kolkata - 700126, West Bengal, India
            </p>
          </div>

          <div className="refund-card">
            <h2>14. Force Majeure</h2>
            <p>
              FORMAX MONEY shall not be liable for any delay or failure to
              process refunds resulting from events beyond our reasonable
              control, including but not limited to acts of God, natural
              disasters, pandemics, war, terrorism, riots, strikes, government
              actions, bank strikes, power outages, internet failures, or
              payment gateway downtime.
            </p>
          </div>

          <div className="refund-card">
            <h2>15. Changes to This Policy</h2>
            <p>
              We reserve the right to update or modify this Refund &
              Cancellation Policy at any time without prior notice. Changes will
              be effective immediately upon posting on our website. Your
              continued use of our services after any changes constitutes
              acceptance of the modified Policy.
            </p>
          </div>

          <div className="refund-card">
            <h2>16. Contact Us</h2>
            <p>
              For any questions about this Refund & Cancellation Policy, please
              contact us:
            </p>
            <p>
              <strong>FORMAX IT SOLUTIONS PRIVATE LIMITED</strong>
              <br />
              N0060, Mochpole, Near Junior School, Nabapally, Barasat,
              <br />
              Kolkata - 700126, West Bengal, India
              <br />
              Email: support@formaxmoney.in
              <br />
              Phone: +91 7890090500
              <br />
              Website: www.formaxmoney.in
            </p>
          </div>
        </div>
      </div>

      <Footer />

      <style>{`
        .page-hero {
          background: linear-gradient(135deg, #0A2540 0%, #1A3A5F 100%);
          padding: 60px 0 70px;
          text-align: center;
        }
        .page-hero h1 {
          font-size: 2.8rem;
          margin-bottom: 16px;
          color: white;
          font-weight: 700;
        }
        .page-hero p {
          color: rgba(255,255,255,0.85);
          max-width: 700px;
          margin: 0 auto;
          font-size: 1.1rem;
        }
        
        .refund-content {
          margin: 60px 0;
        }
        
        .refund-card {
          background: white;
          border-radius: 28px;
          padding: 32px;
          margin-bottom: 30px;
          box-shadow: 0 10px 25px -5px rgba(0,0,0,0.05);
          border: 1px solid #eef2ff;
          transition: all 0.3s ease;
        }
        
        .refund-card:hover {
          border-color: rgba(212, 175, 55, 0.3);
          box-shadow: 0 15px 30px -10px rgba(0,0,0,0.1);
        }
        
        .refund-card h2 {
          font-size: 1.6rem;
          margin-bottom: 16px;
          color: #0A2540;
          font-weight: 700;
        }
        
        .refund-card p {
          margin-bottom: 16px;
          line-height: 1.6;
          color: #475569;
        }
        
        .refund-card ul, .refund-card ol {
          margin-left: 24px;
          margin-bottom: 8px;
        }
        
        .refund-card li {
          margin-bottom: 10px;
          line-height: 1.5;
          color: #475569;
        }
        
        .refund-card .note {
          background: #FEF3C7;
          padding: 12px 16px;
          border-radius: 12px;
          border-left: 4px solid #D4AF37;
          margin-top: 12px;
        }
        
        .refund-card a {
          color: #D4AF37;
          text-decoration: none;
        }
        
        .refund-card a:hover {
          text-decoration: underline;
        }
        
        @media (max-width: 768px) {
          .page-hero {
            padding: 40px 0 50px;
          }
          .page-hero h1 { 
            font-size: 2rem; 
          }
          .page-hero p {
            font-size: 1rem;
            padding: 0 20px;
          }
          .refund-card h2 { 
            font-size: 1.3rem; 
          }
          .refund-card { 
            padding: 24px; 
          }
        }
        
        @media (max-width: 576px) {
          .refund-card ul, .refund-card ol {
            margin-left: 16px;
          }
        }
      `}</style>
    </>
  );
};

export default RefundPolicy;
